import React, {useEffect, useRef, useState} from 'react';
import Tree from 'react-d3-tree';
import {Alert} from 'react-bootstrap';
import RenderForeignObjectNode from './components/nodes/RenderForeignObjectNode';
import AddNodeModal from './components/modals/AddNodeModal';
import {useCenteredTree} from './utils/treeHelpers';
import {NodeTypes} from '../../constants/nodeTypes';
import {useData} from '../../context/ConfigDataContext';
import '../../styles/config.css';

const regularStyles = {
  width: '100%',
  height: 'calc(100vh - 160px)',
  position: 'relative',
};
const fullscreenStyles = {
  width: '100%',
  height: '100%',
  backgroundColor: '#fff',
};
const initialTree = {
  name: '0',
  type: NodeTypes.ADDNODE,
};
const TreeView = () => {
  const [translate, containerRef] = useCenteredTree();
  const nodeSize = {x: 250, y: 300};
  const foreignObjectProps = {width: nodeSize.x, height: nodeSize.y, x: 0};
  const [isFullscreen, setIsFullscreen] = useState(false);
  const treeContainerRef = useRef(null);
  const {treeData, setSelectedNode, setIsEditMode, setEditNodeModalOpen, validateCurrentJson} = useData();
  const addNode = (nodeData) => {
    setEditNodeModalOpen(true);
    setIsEditMode(false);
    setSelectedNode(nodeData.name);
  };
  const toggleFullscreen = () => {
    if (!document.fullscreenElement) {
      treeContainerRef.current.requestFullscreen().catch((e) => {
        console.error('Error attempting to enable full-screen mode:', e);
      });
    } else {
      document.exitFullscreen().catch((e) => {
        console.error('Error attempting to exit full-screen mode:', e);
      });
    }
    setIsFullscreen(!isFullscreen);
  };
  useEffect(() => {
    const onFullscreenChange = () => setIsFullscreen(!!document.fullscreenElement);
    document.addEventListener('fullscreenchange', onFullscreenChange);
    return () => document.removeEventListener('fullscreenchange', onFullscreenChange);
  }, []);
  return (
    <>
      <div style={regularStyles} ref={containerRef}>
        {!validateCurrentJson() && <Alert variant="danger">Invalid JSON</Alert>}
        <div ref={treeContainerRef} style={isFullscreen ? fullscreenStyles : regularStyles}>
          <Tree
            data={treeData || initialTree}
            translate={translate}
            nodeSize={nodeSize}
            renderCustomNodeElement={(rd3tProps) =>
              RenderForeignObjectNode({...rd3tProps, foreignObjectProps, addNode})
            }
            orientation="horizontal"
            collapsible={false}
            depthFactor={375}
            enableLegacyTransitions={true}
            pathFunc="step"
            transitionDuration={300}
            centeringTransitionDuration={300}
          />
        </div>
      </div>
      <AddNodeModal/>
    </>
  );
};
/** ConfigTree wraps TreeView in the treeview container div. */
export const ConfigTree = () => (
  <div className="treeview">
    <TreeView/>
  </div>
);
export default ConfigTree;
